import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import GoldAlertIcon from '@images/vms-account/vms-icons/GoldAlert.svg';
import GreenTickIcon from '@images/vms-account/vms-icons/GreenTick.svg';

type ErrorMessage = 'warning' | 'success';

interface Props {
  children: React.ReactNode;
  type?: ErrorMessage;
  margin?: string;
}

export default function DashboardErrorWrap({ children, type, margin }: Props) {
  if (!children) {
    return null;
  }

  return (
    <Wrapper $type={type} $margin={margin}>
      {type === 'warning' ? (
        <IconWrapper>
          <GoldAlertIcon />
        </IconWrapper>
      ) : null}
      {type === 'success' ? (
        <IconWrapper>
          <GreenTickIcon />
        </IconWrapper>
      ) : null}
      <TextWrapper>{children}</TextWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $type?: ErrorMessage; $margin?: string }>`
  display: flex;
  border-radius: 2px;
  padding: 15px 20px;
  background-color: ${({ $type }) => ($type === 'success' ? Colors.paleGold25 : Colors.paleGold50)};
  gap: 10px;
  align-items: center;
  width: 100%;
  margin: ${({ $margin }) => $margin || '0 0 20px 0'};

  @media (max-width: 767px) {
    padding: 15px 15px;
  }
`;

const IconWrapper = styled.div<{ $type?: ErrorMessage }>`
  width: 20px;
  height: 22px;
`;

const TextWrapper = styled.p`
  color: ${Colors.navyBlue};
  font-family: 'BrownStd';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;

  a {
    margin-left: 7px;
    white-space: nowrap;
  }
`;
